import {palette} from './Palette';

/**
 * Roles for colors. Define different colors with their type or role. Change the color codes from the palette file.
 */
const colors = {
  /**
   * The palette is available to use, but prefer using the name.
   */
  palette,
};

export default colors;
